import * as MixpanelProfilePageActions from '@analytics/mixpanel/actions/ProfilePage';
import { Limiting } from '@api/Celebrities';
import Facebook from '@assets/facebook';
import Twitter from '@assets/twitter';
import Whatsapp from '@assets/whatsapp';
import { useYela } from '@hooks/useYela';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { I18N_PROFILE_CONTEXT, SHARING_TITLE } from '../ProfileForm.constants';
import {
  FacebookShareContainer,
  FormSuccessShareIcon,
  ProfileShareIconsContainer,
  ProfileShareTitle,
  SharingContainer,
  TwitterShareContainer,
  WhatsappShareContainer,
} from './Sharing.styles';

type SharingProps = {
  creatorSlug: string;
  videoLimiting: Limiting;
  audioLimiting: Limiting;
};

export const Sharing = ({ creatorSlug, videoLimiting, audioLimiting }: SharingProps): JSX.Element => {
  const router = useRouter();
  const { t } = useTranslation(I18N_PROFILE_CONTEXT);
  const { language } = useYela();
  const profileURL = process.env.NEXT_PUBLIC_SITE_URL + '/' + language + router.asPath;
  const shouldShare = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' || process.env.NEXT_PUBLIC_ENABLE_SOCIAL_SHARING === 'true';

  const onShareButtonClick = (sharePlatform: string) => {
    MixpanelProfilePageActions.onProfileShareButtonClicked({
      router,
      details: {
        sharePlatform,
        celebrityName: creatorSlug,
        total: `
        ${(audioLimiting.enabled ? audioLimiting.totalSlots : 0) + (videoLimiting.enabled ? videoLimiting.totalSlots : 0)}`,
        videoRemaining: `${videoLimiting.remainingSlots}`,
        audioRemaining: `${audioLimiting.remainingSlots}`,
      },
    });
  };

  return (
    <SharingContainer>
      <ProfileShareTitle>{t(SHARING_TITLE)}</ProfileShareTitle>
      <ProfileShareIconsContainer>
        <WhatsappShareContainer disabled={!shouldShare} url={profileURL} onClick={() => onShareButtonClick('Whatsapp')}>
          <FormSuccessShareIcon>
            <Whatsapp />
          </FormSuccessShareIcon>
        </WhatsappShareContainer>
        <TwitterShareContainer disabled={!shouldShare} url={profileURL} onClick={() => onShareButtonClick('Twitter')}>
          <FormSuccessShareIcon>
            <Twitter />
          </FormSuccessShareIcon>
        </TwitterShareContainer>
        <FacebookShareContainer disabled={!shouldShare} url={profileURL} onClick={() => onShareButtonClick('Facebook')}>
          <FormSuccessShareIcon>
            <Facebook />
          </FormSuccessShareIcon>
        </FacebookShareContainer>
      </ProfileShareIconsContainer>
    </SharingContainer>
  );
};
